import { render, staticRenderFns } from "./FormRegisterFast.vue?vue&type=template&id=51c25b46&scoped=true"
import script from "./FormRegisterFast.vue?vue&type=script&lang=js"
export * from "./FormRegisterFast.vue?vue&type=script&lang=js"
import style0 from "./FormRegisterFast.vue?vue&type=style&index=0&id=51c25b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c25b46",
  null
  
)

export default component.exports